var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41274 11.1475L4.44043 16.1197L5.02641 16.7056L9.99876 11.7334L9.41274 11.1475Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8749 14.3408C8.18955 14.3408 7.63184 14.8984 7.63184 15.5838C7.63184 16.2691 8.18955 16.827 8.8749 16.827C9.56025 16.827 10.118 16.2691 10.118 15.5838C10.118 14.8984 9.56025 14.3408 8.8749 14.3408ZM8.8749 15.9982C8.64658 15.9982 8.46055 15.8126 8.46055 15.5838C8.46055 15.3551 8.64658 15.1695 8.8749 15.1695C9.10321 15.1695 9.28925 15.3551 9.28925 15.5838C9.28925 15.8126 9.10321 15.9982 8.8749 15.9982Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56045 11.0264C4.87511 11.0264 4.31738 11.584 4.31738 12.2694C4.31738 12.9548 4.87511 13.5125 5.56045 13.5125C6.24579 13.5125 6.80352 12.9548 6.80352 12.2694C6.80352 11.584 6.24579 11.0264 5.56045 11.0264ZM5.56045 12.6838C5.33214 12.6838 5.14609 12.4982 5.14609 12.2694C5.14609 12.0407 5.33214 11.8551 5.56045 11.8551C5.78876 11.8551 5.97481 12.0407 5.97481 12.2694C5.97481 12.4982 5.78876 12.6838 5.56045 12.6838Z",
    stroke: "none",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0095 16.9765V17.9906H13.0235H24.9542C24.7833 20.0011 24.1064 21.9419 22.9793 23.6287C21.6636 25.5978 19.7936 27.1325 17.6056 28.0387C15.4177 28.945 13.0102 29.1821 10.6876 28.7201C8.3649 28.2581 6.23136 27.1177 4.55682 25.4432C2.88228 23.7687 1.74189 21.6351 1.27988 19.3125C0.817876 16.9899 1.05499 14.5824 1.96126 12.3944C2.86751 10.2065 4.40222 8.33649 6.37128 7.02081C8.05814 5.89369 9.99888 5.21677 12.0095 5.0459V16.9765Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0237 17.9756L5.03027 23.9699",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5254 13.9791C28.792 13.9791 29.0092 13.7627 28.9993 13.4963C28.942 11.9554 28.6107 10.4358 28.0196 9.00886C27.367 7.43312 26.4103 6.00138 25.2043 4.79536C23.9982 3.58934 22.5665 2.63267 20.9908 1.97998C19.5639 1.38894 18.0441 1.05764 16.5033 1.00033C16.2368 0.990414 16.0205 1.20754 16.0205 1.47423V13.4962C16.0205 13.7628 16.2367 13.9791 16.5034 13.9791H28.5254Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3788 10.3434C22.0128 10.3434 22.4478 10.0067 22.6616 9.71294L23.2145 10.2718C23.0303 10.5369 22.4405 11.1315 21.3567 11.1315C20.273 11.1315 19.4326 10.5225 19.1598 9.48373H18.3857L18.511 8.94639H19.0713C19.0639 8.8747 19.0639 8.79594 19.0639 8.71711C19.0639 8.63829 19.0639 8.56666 19.0713 8.49504H18.3857L18.511 7.9577H19.1525C19.4252 6.91169 20.273 6.30273 21.364 6.30273C22.4405 6.30273 23.0303 6.89734 23.2145 7.1696L22.6616 7.72129C22.4478 7.43466 22.0276 7.09078 21.4009 7.09078C20.8996 7.09078 20.3688 7.34869 20.133 7.9577H21.9834L21.8654 8.49504H20.015C20.0076 8.56666 20.0076 8.63829 20.0076 8.71711C20.0076 8.79594 20.0076 8.8747 20.015 8.94639H21.7769L21.6515 9.48373H20.1403C20.3763 10.0855 20.8923 10.3434 21.3788 10.3434Z",
    stroke: "none",
    fill: "current"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "transparent"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.142c0c8f64d93606b6633a591405a98e.svg";
export { ForwardRef as ReactComponent };